'use strict';

(function(z, Backbone, Translator){

    var MaterialImportModel = Backbone.Model.extend({

        /**
         * URL către ruta Symfony
         */
        url: function() {
            return '/material/import';
        },

        /**
         * Validare model
         */
        validation: {
            'type': [{
                required: true,
                msg: Translator.trans('js.error_message_materialform_type_required')
            }],
            'file': {
                fn: function(val, attr, computed) {

                    if (computed.isTemplateEmpty) {
                        return Translator.trans('js.error_message_importform_template_required');
                    }

                    if (computed.isTemplateInvalidType) {
                        return Translator.trans('js.error_message_importform_template_invalidtype');
                    }

                    if (computed.isTemplateInvalidSize) {
                        return Translator.trans('js.error_message_importform_template_invalidsize');
                    }
                }
            }
        }
    });

    z.MaterialImportModel = MaterialImportModel;

})(window.z = window.z || {}, Backbone, Translator);
